import * as React from 'react';
import { AutoSuggestMenuItemRenderProps } from './Types';
import { stripHtml } from 'util/StringUtil';
import { ModelStatus } from '../../../../../Roc.SharedClientApp/types/model-status';

const getClassByStatus = (status: ModelStatus): string => {
	switch (status) {
		case ModelStatus.Deleted:
			return 'autosuggest-menu__text--deleted';
		case ModelStatus.Archived:
			return 'autosuggest-menu__text--archived';
	}

	// for published, or others
	return '#000';
};

/**
 * Renders the contents of a single AutoSuggest item.
 *
 * @class AutoSuggestMenuItem
 * @extends {React.Component<AutoSuggestMenuItemRenderProps>}
 */
const AutoSuggestMenuItem: React.SFC<AutoSuggestMenuItemRenderProps> = ({ item }) => {
	if (item.status && item.status !== ModelStatus.Published) {
		return (
			<span className={getClassByStatus(item.status)}>
				{item.label} ({item.status})
			</span>
		);
	}

	return <>{stripHtml(item.label)}</>;
};

export default AutoSuggestMenuItem;
